<template>
    <el-drawer title="添加到CRM" class="erpDrawer" :append-to-body="true" :visible.sync="innerDrawer" :wrapper-closable="false" size='497px' :show-close="false" wrapperClosable>
        <el-form  :key="datekey" v-if="erpGetFlag == 0" :model="crmFormData" :rules="rules" ref="crmForm" label-width="90px" class="crmForm">
               <el-form-item label="添加至" description="" class="addTo">
                    临时区
               </el-form-item>
               <el-form-item label="姓名" prop="contactName">
                    <el-input v-model.trim="crmFormData.contactName" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="gendertype">
                    <el-radio-group v-model="crmFormData.gendertype">
                    <el-radio label="MALE">男</el-radio>
                    <el-radio label="FEMALE">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="办公电话" prop="phone">
                    <el-input :disabled="idSendValDisabledP" v-model="crmFormData.phone" maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="mobile">
                    <el-input :disabled="idSendValDisabledM" v-model="crmFormData.mobile" maxlength="11" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="微信" prop="weixin">
                    <el-input v-model="crmFormData.weixin" maxlength="30" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="职务" prop="title">
                    <el-input v-model.trim="crmFormData.title" maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="常用Email" prop="email">
                    <el-input :disabled="idSendValDisabledE" v-model="crmFormData.email" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="决策权" prop="makedecisiontype">
                    <el-radio-group v-model="crmFormData.makedecisiontype">
                        <el-radio label="Decisionmakers">决策人</el-radio>
                        <el-radio label="Effect of human">影响人</el-radio>
                        <el-radio label="The execution layer">执行层</el-radio>
                    </el-radio-group>
                </el-form-item>
        </el-form>
        <div class="getStatus" v-else>
            <template v-if="erpGetFlag == 1">
                    <img src="@/assets/icon/sucess.svg" alt="">
                    <p class="tit">领取成功</p>
                    <p class="txt">{{erpbackTip}}</p>
            </template>
             <template v-if="erpGetFlag == 2">
                    <img src="@/assets/icon/fail.svg" alt="">
                    <p class="tit">领取失败</p>
                    <p class="txt">{{erpbackTip}}</p>
            </template>
        </div>
        <div class="drawer_footer">
            <el-button w88 size="small" type="primary" :loading="getLoading" v-if="erpGetFlag == 0" @click="submitErp('crmForm')">提交</el-button>
            <el-button w88 size="small" type="primary" v-else @click="closeDrawer">好的</el-button>
        </div>
    </el-drawer>
</template>
<script>
export default {
    props:{
       erpGetFlag:{
           type:Number,
           default:0
       },
       erpbackTip:{
           type:String,
           default:''
       },
    },
     data(){
         var validMobile = (rule, value, callback) => {
            if (!this.crmFormData.mobile) {
                callback(new Error('手机不能为空'))
            } else {
                if (this.crmFormData.mobile) {
                    const reg = /1[3-9]\d{9}$/
                    if (!reg.test(this.crmFormData.mobile)) {
                    callback(new Error('请输入正确的手机'))
                    } else {
                    callback()
                    }
                } else {
                    callback()
                }
            }
        }
         return{
             getLoading:false,
             idSendValDisabledP:false,
              idSendValDisabledM:false,
              idSendValDisabledE:false,
             datekey:Date.now(),
             innerDrawer:false,
             crmFormData: {
                    contactName: '',//姓名
                    gendertype:"MALE",//性别
                    phone:"",//办公电话
                    mobile:'',//手机号
                    weixin:'',//微信
                    title:'',//职务
                    email:'',//常用Email
                    makedecisiontype:"Decisionmakers",//决策权 决策人Decisionmakers、影响人Effect of human、执行层The execution layer
                    },
             makedecisiontypeVal:{'决策人':'Decisionmakers','影响人':'Effect of human','执行层':'The execution layer'},
             rules:{
                contactName:[
                    { required: true, message: '请填写姓名', trigger: 'blur' }
                ],
                gendertype:[
                    { required: true, message: '请选择性别', trigger: 'change' }
                ],
                mobile:[
                    { required: true, validator: validMobile, trigger: 'blur' },
                ],
                title:[
                    { required: true, message: '请填写职务', trigger: 'blur' }
                ],
                makedecisiontype:[
                    { required: true, message: '请选择决策权', trigger: 'change' }
                ],
             }
         }
     },
     mounted(){
     },
     methods:{
         iniFun(item,sign){
             this.datekey = Date.now()
             this.innerDrawer = true
             this.getLoading = false
            //  this.$nextTick(()=>{
            //      this.resetData()
            //  })
             this.resetData()
              this.crmFormData.contactName = item.contactName
               if(item.content){
                         if(item.type == 1){
                            this.crmFormData.mobile = item.content
                            this.idSendValDisabledM = true
                        }else if(item.type == 2){
                            this.crmFormData.phone = item.content
                            this.idSendValDisabledP = true
                        }else if(item.type == 3){
                            this.crmFormData.email = item.content
                            this.idSendValDisabledE = true
                        }

               }else{
                   this.idSendValDisabledM = false
                   this.idSendValDisabledP = false
                   this.idSendValDisabledE = false
               }
         },
         submitErp(formName){
              this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.getLoading = true
                    this.$emit('submitCrmFormData',this.crmFormData)
                } else {
                    console.log('error submit!!');
                    return false;
                }
              });
         },
         resetData(){
             this.crmFormData.contactName = ''
             this.crmFormData.gendertype = 'MALE'
             this.crmFormData.phone = ''
             this.crmFormData.mobile = ''
             this.crmFormData.weixin = ''
             this.crmFormData.title = ''
            this.crmFormData.email = ''
            this.crmFormData.makedecisiontype = 'Decisionmakers'
            this.idSendValDisabledM = false
            this.idSendValDisabledP = false
            this.idSendValDisabledE = false
            //  this.$refs.crmForm.resetFields()
         },
         closeDrawer(){
            this.resetData()
            this.innerDrawer = false
         }
     }
}
</script>
<style lang='scss' scoped>
      
      .erpDrawer{
            .el-drawer__header{
                height: 50px;
                line-height: 50px;
                padding-left: 24px;
                box-sizing: border-box;
            }
            .drawer_footer{
                position: absolute;
                right: 0px;
                left: 0px;
                bottom: 0px;
                border-top: 1px solid #F1F1F2;
                padding: 15px 0;
                background: #FFFFFF;
                .el-button{
                    float: right;
                    margin-right: 24px;
                }
            }
            .getStatus{
                text-align: center;
                padding-top: 60px;
                p{
                    margin-bottom: 8px;
                }
                .tit{
                    font-weight: 400;
                    color: #333333;
                    line-height: 30px;
                    font-size: 22px;
                }
                .txt{
                        font-weight: 400;
                        color: #999999;
                        line-height: 21px;
                        font-size: 13px;
                }
            }
        }
    ::v-deep{
        .el-drawer__header{
                height: 50px;
                line-height: 50px;
                padding-left: 24px !important;
                box-sizing: border-box;
                font-weight: bold;
                color: #333333;
                font-size: 14px;
                border-bottom: 1px solid rgba(241, 241, 242, 1);
            }
            .crmForm{
                    .el-input__inner{
                    line-height: 32px;
                    height: 32px;
                }
                .el-radio__label{
                    padding-left: 6px;
                    box-sizing: border-box;
                }
                .el-radio{
                    margin-right: 24px;
                }
            }
            
    }
    
    .crmForm{
        margin-bottom: 70px;
        .el-form-item{
            .el-input{
                width: 240px;
            }
            &.addTo{
                height: 80px;
                background:rgba(241, 241, 242, 0.3);
                padding: 24px 0;
                box-sizing: border-box;
            }
        }
        
    }
    
</style>
<style lang='scss'>
  ::v-deep{
      .erpDrawer{
            .el-drawer__header{
                height: 50px;
                line-height: 50px;
                padding-left: 24px;
                box-sizing: border-box;
            }
        }
  }
     
</style>